module.exports = __webpack_public_path__ + "static/media/industry_hover2.03979fd6.svg";